var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-row",
    { staticClass: "table" },
    [
      _c(
        "el-row",
        { staticClass: "row-bg", attrs: { gutter: 24 } },
        [
          _c(
            "el-col",
            { attrs: { span: 5 } },
            [
              _c(
                "el-input",
                {
                  staticClass: "input-with-select",
                  attrs: { placeholder: "请输入搜索内容" },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.search.apply(null, arguments)
                    },
                  },
                  model: {
                    value: _vm.inputVal,
                    callback: function ($$v) {
                      _vm.inputVal = $$v
                    },
                    expression: "inputVal",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100px" },
                      attrs: { slot: "prepend", placeholder: "请选择" },
                      slot: "prepend",
                      model: {
                        value: _vm.select,
                        callback: function ($$v) {
                          _vm.select = $$v
                        },
                        expression: "select",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "问题ID", value: "1" },
                      }),
                      _c("el-option", {
                        attrs: { label: "问题标题", value: "2" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 5 } },
            [
              _c(
                "el-input",
                {
                  staticClass: "input-with-select",
                  attrs: { placeholder: "请输入搜索内容" },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.search.apply(null, arguments)
                    },
                  },
                  model: {
                    value: _vm.inputValName,
                    callback: function ($$v) {
                      _vm.inputValName = $$v
                    },
                    expression: "inputValName",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100px" },
                      attrs: { slot: "prepend", placeholder: "请选择" },
                      slot: "prepend",
                      model: {
                        value: _vm.selectName,
                        callback: function ($$v) {
                          _vm.selectName = $$v
                        },
                        expression: "selectName",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "用户名", value: "1" },
                      }),
                      _c("el-option", { attrs: { label: "姓名", value: "2" } }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-button",
                {
                  staticClass: "tb-button",
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.search },
                },
                [_vm._v("搜 索")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "tb-button",
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.reset },
                },
                [_vm._v("重 置")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticClass: "tb-list",
          attrs: {
            data: _vm.dataList,
            border: "",
            fit: "",
            "highlight-current-row": "",
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "学号", align: "center", prop: "loginName" },
          }),
          _c("el-table-column", {
            attrs: { label: "姓名", align: "center", prop: "name" },
          }),
          _c("el-table-column", {
            attrs: {
              label: "题号",
              align: "center",
              prop: "contestProblemNum",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "[id]标题", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        "[" +
                          _vm._s(scope.row.problem_id) +
                          "]" +
                          _vm._s(scope.row.problemName)
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm.editData.raceRule !== "ACM"
            ? _c("el-table-column", {
                attrs: { label: "得分", align: "center" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(scope.row.pass_rate * 100)),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3319888401
                ),
              })
            : _vm._e(),
          _c("el-table-column", {
            attrs: { label: "结果", align: "center", width: "130" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "type-span",
                        style:
                          "backgroundColor" +
                          ":" +
                          _vm.getStateColor(scope.row.result),
                        on: {
                          click: function ($event) {
                            return _vm.subDetail(scope.row, "longsince")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.getSubType(scope.row.result)) + " ")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "运行时间(ms)", align: "center", prop: "time" },
          }),
          _c("el-table-column", {
            attrs: { label: "私用内存(KB)", align: "center", prop: "memory" },
          }),
          _c("el-table-column", {
            attrs: {
              label: "代码长度(B)",
              align: "center",
              prop: "code_length",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "编程语言", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(" " + _vm._s(_vm.getLanText(scope.row.language))),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "提交时间", align: "center", prop: "in_date" },
          }),
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          "current-page": _vm.pagination.currentPage,
          "page-sizes": _vm.pagination.pageSizes,
          "page-size": _vm.pagination.pageSize,
          layout: _vm.pagination.layout,
          total: _vm.pagination.total,
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "记录详情",
            width: "900px",
            visible: _vm.showDialog,
            "append-to-body": "",
            "before-close": () => (_vm.showDialog = false),
          },
          on: {
            "update:visible": function ($event) {
              _vm.showDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "dia-tit", attrs: { slot: "title" }, slot: "title" },
            [_c("i"), _c("span", [_vm._v("提交详情")])]
          ),
          _c(
            "div",
            [
              _vm.showDialog
                ? _c("detailRecord", { attrs: { item: _vm.rowData } })
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }